var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import Box from '@mui/material/Box';
import Input from '@mui/material/Input';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import FormHelperText from '@mui/material/FormHelperText';
import { Delimiter } from '../../atoms/Delimiter';
import * as api from '../../../api';
import { EButtonTypes } from '../../../types';
import { useErrorHandler } from '../../../hooks/useErrorHandler';
const commonModalStyles = {
    padding: '30px',
    maxWidth: '668px',
    minWidth: '400px',
    maxHeight: 'calc(100vh - 200px)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
};
const InputContainer = styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const Error = styled.div `
  font-style: normal;
  font-weight: 400;
  font-size: 1.2em;
  //line-height: 20px;
  color: red;
  position: absolute;
  top: 105%;
  z-index: 100;
`;
const requiredFieldError = 'Это поле необходимо заполнить';
const validationSchema = Yup.object().shape({
    realName: Yup.string().required(requiredFieldError),
    gameName: Yup.string().required(requiredFieldError),
});
export function CreatePlayer({ matchId, setPlayersChanged, onClose }) {
    const { errorHandler, setSuccess } = useErrorHandler();
    const initialValues = {
        realName: '',
        gameName: '',
    };
    const renderError = (message) => _jsx(Error, { children: message });
    const addPlayer = (playerId) => __awaiter(this, void 0, void 0, function* () {
        try {
            // console.log('AddPlayersToMatch addPlayer', playerId, matchId)
            yield api.addPlayerToMatch({ playerId, matchId: matchId || '' });
            setPlayersChanged(true);
            setSuccess('Игрок успешно добавлен в игру');
            // nav(-1)
        }
        catch (e) {
            // eslint-disable-next-line no-console
            console.error('AddPlayersToMatch addPlayer error', e.response);
            errorHandler(e);
        }
    });
    const createPlayer = (data) => __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield api.createPlayer(data);
            // console.log('AddPlayersToMatch createPlayer', response)
            yield addPlayer(response.id);
            setSuccess('Игрок создан и добавлен к игре');
            // backToMatch()
            // searchPlayer(data)
        }
        catch (e) {
            console.error('AddPlayerToMatch createPlayer error', e.response);
            errorHandler(e);
        }
    });
    const onSubmit = (data, actions) => __awaiter(this, void 0, void 0, function* () {
        // console.log('CreatePlayer onSubmit', data)
        yield createPlayer(data);
        setPlayersChanged(true);
        onClose === null || onClose === void 0 ? void 0 : onClose();
    });
    return (_jsxs(Box, Object.assign({ sx: commonModalStyles }, { children: [_jsx(Typography, Object.assign({ variant: "h4" }, { children: "\u0421\u043E\u0437\u0434\u0430\u043D\u0438\u0435 \u043D\u043E\u0432\u043E\u0433\u043E \u0438\u0433\u0440\u043E\u043A\u0430" })), _jsx(Delimiter, { top: "50px" }), _jsx(Formik, Object.assign({ initialValues: initialValues, validationSchema: validationSchema, onSubmit: onSubmit }, { children: ({ values, setFieldValue, errors }) => (_jsxs(Form, { children: [_jsxs(InputContainer, { children: [_jsx(Input, { sx: { width: '100%', color: '#fff' }, size: "medium", placeholder: "\u0418\u043C\u044F", onChange: (event) => setFieldValue('realName', event.target.value), error: !!errors.realName }), _jsx(FormHelperText, Object.assign({ sx: { width: '100%' } }, { children: renderError(errors.realName || '') }))] }), _jsx(Delimiter, { top: "30px" }), _jsxs(InputContainer, { children: [_jsx(Input, { sx: { width: '100%', color: '#fff' }, name: "gameName", placeholder: "\u0418\u0433\u0440\u043E\u0432\u043E\u0439 \u043D\u0438\u043A", onChange: (event) => setFieldValue('gameName', event.target.value), error: !!errors.gameName }), _jsx(FormHelperText, Object.assign({ sx: { width: '100%', color: '#fff' } }, { children: renderError(errors.gameName || '') }))] }), _jsxs(InputContainer, { children: [_jsx(Delimiter, { top: "40px" }), _jsx(Button, Object.assign({ type: EButtonTypes.SUBMIT, variant: "contained" }, { children: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C" }))] })] })) }))] })));
}
